(function () {
  const modal = document.querySelector('[data-size-guide-modal]');
  if (!modal) return;

  const triggers = document.querySelectorAll('[data-size-guide-open]');
  const closers = modal.querySelectorAll('[data-size-guide-close]');

  function open() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  triggers.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); open(); }));
  closers.forEach((c) => c.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
})();
